import SuperagentBase from '../shared/superagent-base';

export default class ListingResource extends SuperagentBase {
    getById(token, listingId) {
        return new Promise((resolve, reject) => {
            this.request
                .get(`api/listings/${listingId}`)
                .set('api-key', 'Bearer ' + token)
                .end((error, res) => {
                    error ? reject(error) : resolve(res.body);
                });
        });
    }

    createNewListing(token, listing) {
        return new Promise((resolve, reject) => {
            this.request
                .post(`api/listings`)
                .set('api-key', 'Bearer ' + token)
                .send(listing)
                .end((error, res) => {error ? reject(error) : resolve(res.body);});
        });
    }

    convertListing(token, conversionData) {
        return new Promise((resolve, reject) => {
            this.request
                .post(`api/listings/${conversionData.listingId}/convert`)
                .set('api-key', 'Bearer ' + token)
                .send(conversionData)
                .end((error, res) => {
                    error ? reject(error) : resolve(res.body);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/listings/listing-resource.js